export const CLIENT_APP_PLAY_STORE_LINK = "https://play.google.com/store/apps/details?id=in.wealthy.android.wealthy";
export const CLIENT_APP_APP_STORE_LINK = 'https://itunes.apple.com/in/app/wealthy/id1222950243?mt=8';